import { createAction, props } from '@ngrx/store';
import { User } from '@iris-sites/interfaces/sites.interfaces';

export const storeUserDetail = createAction(
  '[User] Store User',
  props<{ user: User }>(),
);

export const setLoading = createAction(
  '[User] Set Loading',
  props<{ loading: boolean }>(),
);

export const onUserDeactivated = createAction(
  '[User] User Deactivated',
  props<{ userId: string }>(),
);
